<template>
    <div class="password-block">
        <div class="open-wrapper pointer form-group" @click="openModal">
            <slot>
                <a href="javascript://void(0)" class="btn btn-excellent">Change Password</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               height="auto">
            <div class="dashboard-block">
                <header>
                    <h4>Update Password</h4>
                </header>

                <form method="POST" :action="url" @submit.prevent="save" accept-charset="UTF-8" novalidate="novalidate">
                    <input name="_method" type="hidden" value="PUT">
                    <input name="_token" type="hidden" :value="csrfToken">

                    <div class="row">
                        <div class="col-sm-6 form-group" :class="{'has-error': errors.has('User[password]')}">
                            <label for="user-password">Password</label>
                            <input
                                autocomplete="new-password"
                                class="form-control"
                                id="user-password"
                                name="User[password]"
                                ref="password"
                                type="password"
                                v-validate="'required|min:8'">

                            <span v-show="errors.has('User[password]')" class="help-block">
                                {{ errors.first('User[password]') }}
                            </span>
                        </div>

                        <div class="col-sm-6 form-group" :class="{'has-error': errors.has('User[password_confirm]')}">
                            <label for="user-password-confirm">Password Confirm</label>
                            <input
                                autocomplete="new-password"
                                class="form-control"
                                id="user-password-confirm"
                                name="User[password_confirm]"
                                type="password"
                                v-validate="'required|confirmed:password|min:8'">

                            <span v-show="errors.has('User[password_confirm]')" class="help-block">
                                {{ errors.first('User[password_confirm]') }}
                            </span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6 col-md-4 pull-right">
                            <button type="submit" class="btn btn-success btn-block">
                                Save
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            modalId: {
                default(){
                    return Math.random().toString();
                },
                type: String
            },

            userId: {
                type: String,
                required: true
            },

            csrfToken: {
                type: String,
                required: true
            },
        },
        computed: {
            url(){
                return '/users/' + this.userId;
            }
        },
        data(){
            return {
                show: false,
            };
        },
        methods: {
            save(){
                return this.$validator.validateAll()
                    .then( ( valid ) => {
                        if( valid ){
                            $( this.$el ).find( 'form' ).submit();
                        }
                    } );
            },

            openModal(){
                this.$modal.show( this.modalId );
            }
        }
    }
</script>